<template>

    <div id="skills_tab" class="flex_content" v-if="currentEval.saven_test">

        <div class="matching_bar_container" :class="matchingRange">
            <div class="matching_bar container">
                <div class="matching_label_container">
                    <div class="matching_title">Total match</div>
                </div>
                <div class="matching_container">
                    <div class="matching_number" >
                        <animated-number :value="matching" :formatValue="formatValue" :duration="800" />%
                    </div>
                </div>

                <div class="fiability_container">
                    <div class="fiability_label">{{ $t('modules.evaluations.edit.fiabilityScore') }}</div>
                    <div class="fiability_score">
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(1)}"></i>
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(2)}"></i>
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(3)}"></i>
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(4)}"></i>
                        <i class="zmdi zmdi-star" :class="{active: starIsChecked(5)}"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="container">
            <div class="radial_scores_container">
                <div class="job_profiler_results">
                    <div class="job_profiler_label">{{ $t('modules.evaluations.edit.job_profiler_company') }}</div>
                    <div class="job_profiler_value">
                        {{  $t('modules.evaluations.edit.job_profiler_values.company.' + currentEval.saven_test.job_profiler_company) }}
                    </div>
                </div>
                <div class="job_profiler_results">
                    <div class="job_profiler_label">{{ $t('modules.evaluations.edit.job_profiler_job') }}</div>
                    <div class="job_profiler_value">
                        {{  $t('modules.evaluations.edit.job_profiler_values.job.' + currentEval.saven_test.job_profiler_job) }}
                    </div>
                </div>
                <div class="job_profiler_results">
                    <div class="job_profiler_label">{{ $t('modules.evaluations.edit.job_profiler_sector_type') }}</div>
                    <div class="job_profiler_values">
                        <div v-for="(sector, index) in currentEval.saven_test.job_profiler_sector" :key="index" class="job_profiler_value">
                            {{  $t('modules.evaluations.edit.job_profiler_values.sector_types.' + sector) }}
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="skills_scores_panel_container ">
            <Sight2Scores :evaluation="currentEval" :currentRef="currentEval.saven_test.sight_ref" />
        </div>

    </div>

</template>

<script>
    import Sight2Scores from '../scores/sight2Scores'
    import SkillScore from "../scores/skillScore";
import AnimatedNumber from "animated-number-vue";


    export default {
        name: 'ScoresTab',
        components: {
            Sight2Scores,
            AnimatedNumber,
            SkillScore
        },
        mounted() {
            setTimeout(() => {
                this.localMatching = this.matching
            }, 500)
            this.intervalid1 = setInterval(() => {
                if(this.localFiability != this.fiability){this.localFiability = this.localFiability + 1}
            }, 150);
        },
        data(){
            return {
                localMatching: 0,
                localFiability: 0,
                matchingRange: 'low',
            }
        },
        computed: {
            currentEval(){
                return this.$store.state.EvalStore.currentEval
            },
            fiability(){
                return this.currentEval.saven_test.validity_score
            },
            matching(){
                return this.currentEval.saven_test.matching_score
            }
        },
        methods: {
            formatValue(val){
                    if(val < 25){this.matchingRange = 'low'}
                    if(val >= 25 && val < 50){this.matchingRange = 'middleLow'}
                    if(val >= 50 && val < 75){this.matchingRange = 'middleHigh'}
                    if(val >= 75){this.matchingRange = 'high'}
                return val.toFixed(0)
            },
            starIsChecked(val){
                return this.localFiability >= val
            }
        }
    }
</script>

<style lang="scss" scoped>
#skills_tab{
    .skills_scores_panel_container{
        background: $white;
    }
}
.eval_tabs{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    background-color: $white;
}

.radial_scores_container{
    padding: 50px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 150px;
    .job_profiler_results{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .job_profiler_label{
            font-weight: 600;
            font-size: 1.25rem;
            text-align: center;
             margin-bottom: 8px;
        }
        .job_profiler_value{
            text-align: center;
            background: $info;
            border-radius: 3px;
            padding: 2px 6px;
            color: white;
            font-weight: 500;
            font-size: 1.15rem;
            margin: 6px;
        }
        .job_profiler_values{
            display: flex;
        }

    }
}
.matching_bar_container{
    transition: .3s all;
    &.low{
        background: $score-diff5;
    }
    &.middleLow{
        background: $score-diff4;
    }
    &.middle{
        background: $score-diff3;
    }
    &.middleHigh{
        background: $score-diff2;
    }
    &.high{
        background: $score-diff1;
    }
    .matching_bar{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        .matching_label_container{
            .matching_title{
                color: white;
                font-size: 1.5rem;
                font-weight: 600;

            }
        }
        .matching_container{
            max-width: 200px;
            height: 90px;
            margin-left: auto;
            .matching_number{
                font-size: 7rem;
                font-weight: 800;
                letter-spacing: -4px;
                margin-top: -28px;
                transition: .3s all;
                color: white;
            }
        }
        .fiability_container{
            max-width: 200px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 0;
            margin-left: auto;
            .fiability_label{
                font-weight: 500;
                color: white;
                margin-right: 12px;
                font-size: 1.25rem;
            }
            .fiability_score{
                .zmdi{
                    font-size: 1.5rem;
                    transition: .3s all;
                    color: white;
                    opacity: .5;
                    &.active{
                        opacity: 1;
                    }
                }
            }
        }
    }
}

</style>